(function(){
  const THRESHOLD=7500;
  function formatMoney(c){return'£'+(c/100).toFixed(2)}

  /* Pop Protector cases must never appear as upsell candidates — they're
     Unlisted, but Unlisted just means "hidden from nav/search", not
     invisible to these AJAX endpoints, so they're excluded by handle
     everywhere a candidate list is built. */
  var CASE_HANDLES=['pop-protector-clear','pop-protector-blood-splatter','pop-protector-ectoplasm'];

  /* bundle-3-for-10's real price is £12, not £10 — the tag name is stale
     (kept as-is so it keeps targeting the real Shopify Buy X Get Y
     discount) but was never renamed. Shared by the existing per-line
     badge AND the new "complete the deal" upsell heading, so this stale-
     price exception only ever needs fixing in one place. */
  function bundlePriceLabel(tag){
    var raw=tag.split('bundle-3-for-')[1];
    return tag==='bundle-3-for-10'?'12':raw;
  }

  /* Mirrors snippets/gw-badge-slot.liquid's tag logic. */
  function bundleTagOf(tags){
    if(!tags||!tags.length)return null;
    for(var i=0;i<tags.length;i++){if(tags[i].indexOf('bundle-3-for-')===0)return tags[i];}
    return null;
  }
  function franchiseTagOf(tags){
    if(!tags||!tags.length)return null;
    for(var i=0;i<tags.length;i++){if(tags[i].indexOf('franchise:')===0)return tags[i];}
    return null;
  }
  function bundleBadgeHtml(tags){
    var tag=bundleTagOf(tags);
    if(!tag)return'';
    return '<span class="gw-drawer__bundle-badge">3 for £'+bundlePriceLabel(tag)+'</span>';
  }
  /* Mirrors the metafield check in snippets/gw-badge-slot.liquid,
     via the same "web-exclusive" tag used by search-drawer.liquid, for
     the same reason: product.metafields aren't in the /products/{handle}.js
     response this file already fetches for the bundle badge (checked —
     that response has tags but no metafields field), so no extra request
     is needed, just check for this tag on the same data. */
  function webExclusiveBadgeHtml(tags){
    if(!tags||tags.indexOf('web-exclusive')===-1)return'';
    return '<span class="gw-drawer__webex-badge">Web Exclusive</span>';
  }

  function escapeHtml(s){
    return String(s==null?'':s).replace(/[&<>"']/g,function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* /products/{handle}.js gives tags (no "collections" field — confirmed
     by testing, that field simply isn't in this endpoint's response), so
     it's the one source used everywhere tags are needed: per-line
     badges AND the upsell logic's deal/franchise detection. Cached per
     handle for the session — tags don't change while someone's shopping,
     and the same handle often gets looked up twice in one render (once
     for its own line, once as a candidate elsewhere). */
  var productDataCache={};
  function fetchProductData(handle){
    if(productDataCache[handle]) return productDataCache[handle];
    var p=fetch('/products/'+handle+'.js').then(function(r){return r.json();}).catch(function(){return null;});
    productDataCache[handle]=p;
    return p;
  }

  /* The last full /cart.js response rendered, kept so click handlers (the
     +/- steppers, remove) can look up a line's sibling Pop/case without a
     network round trip before deciding what to do. Always replaced with
     a fresh server response after every change — never mutated locally. */
  var currentCart = null;

  /* ---- Case <-> Pop linking (Round 3) ------------------------------------
     A case line carries a hidden `_for_variant` property (set by
     assets/pop-case-picker.js) pointing at its Pop's variant id, alongside
     the visible "For" property already shown under the line. Rules:
       - lowering a Pop's quantity below its case's quantity caps the case
         to match
       - removing a Pop (quantity 0) removes its linked case line(s) too
       - a case's own + can't take it above its Pop's current quantity
       - raising a Pop's quantity never auto-adds or auto-raises a case
     applyCaseLinkRules is idempotent and safe to call after ANY cart
     change from anywhere (the drawer's own controls, "Fans also love",
     or Dawn's stock /cart page via the pubsub hook wired at the bottom of
     this file) — it only ever fixes real violations, never invents one. */
  function findPopForCase(cart, caseItem){
    var forVariant = caseItem.properties && caseItem.properties._for_variant;
    if(!forVariant) return null;
    return cart.items.find(function(i){ return String(i.variant_id)===String(forVariant); }) || null;
  }

  function applyCaseLinkRules(cart){
    var changes=[];
    cart.items.forEach(function(item){
      var pop=findPopForCase(cart,item);
      var forVariant=item.properties&&item.properties._for_variant;
      if(!forVariant) return; // not a case line
      if(!pop){
        changes.push({id:item.key,quantity:0});
      } else if(item.quantity>pop.quantity){
        changes.push({id:item.key,quantity:pop.quantity});
      }
    });
    if(!changes.length) return Promise.resolve(cart);
    return changes.reduce(function(p,change){
      return p.then(function(){
        return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(change)});
      });
    },Promise.resolve()).then(function(){
      return fetch('/cart.js').then(function(r){return r.json();});
    });
  }

  function updateCartTotals(cart){
    const rem=Math.max(0,THRESHOLD-cart.total_price);
    const pct=Math.min(100,(cart.total_price/THRESHOLD)*100);
    document.getElementById('gw-drawer-shipping').innerHTML=`<div class="gw-drawer__shipping-text"><span class="gw-drawer__shipping-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00b4b4" stroke-width="2" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></span>${rem>0?`Spend <strong style="color:#fff;margin:0 3px">${formatMoney(rem)}</strong> more for free UK shipping`:'<strong style="color:#00b4b4">You\'ve unlocked free UK shipping!</strong>'}</div><div class="gw-drawer__shipping-bar"><div class="gw-drawer__shipping-fill" style="width:${pct}%"></div></div>`;
    document.getElementById('gw-drawer-subtotal').textContent=formatMoney(cart.total_price);
    updateHeaderCount(cart);
  }

  function updateHeaderCount(cart){
    /* querySelectorAll, not querySelector — the slim sticky header
       (gw-slim-header.liquid) renders its own cart badge too, and both
       need to stay in sync. Scoped to data-gw-cart-count/-bubble
       specifically (not the shared .cart-count-bubble class) because
       the wishlist badge also carries .cart-count-bubble for styling
       reuse — matching on that class alone would wrongly overwrite the
       wishlist's own count with the cart's. */
    document.querySelectorAll('[data-gw-cart-count]').forEach(function(el){
      el.textContent=cart.item_count;
    });
    document.querySelectorAll('[data-gw-cart-bubble]').forEach(function(bubble){
      bubble.style.display = cart.item_count>0 ? '' : 'none';
    });
  }

  /* One full cart line: image, title, variant, "For: X" (case lines
     only), badges, line total, qty stepper, remove. `productData` is
     this line's own /products/{handle}.js response (tags), already
     fetched by renderCart before any line is built — badges render
     synchronously from it instead of each line firing its own fetch. */
  function renderLine(item, isNew, productData){
    const el=document.createElement('div');
    el.className='gw-drawer__product-item'+(isNew?' gw-drawer__product-item--new':'');
    el.dataset.key=item.key;
    el.dataset.variantId=item.variant_id;
    const forVariant=item.properties&&item.properties._for_variant;
    if(forVariant) el.dataset.forVariant=forVariant;
    const vt=item.variant_title&&item.variant_title!=='Default Title'?item.variant_title:'';
    // "For" (Pop Protector cases) and "With" (gw-addon-picker, e.g. the
    // beanie+gloves offer) are both just visible labels on top of the
    // same generic _for_variant link — whichever one a line actually
    // carries is shown using its own word, so new add-on offers can pick
    // whatever word reads best without a cart-drawer.js change.
    var forPropKey=['For','With'].find(function(k){ return item.properties && item.properties[k]; });
    const forLabel=forPropKey?item.properties[forPropKey]:null;
    const tags=productData?productData.tags:null;
    // Shopify's /cart.js already gives every line its POST-discount
    // price (line_price) alongside the pre-discount one
    // (original_line_price) and which discount(s) actually applied
    // (item.discounts, each with its own .title) — no calculation
    // needed here, just deciding whether to show the struck-through
    // version at all.
    const hasDiscount=item.original_line_price!==item.line_price;
    const priceHtml=hasDiscount
      ? `<p class="gw-drawer__product-price"><s class="gw-drawer__product-price--was">${formatMoney(item.original_line_price)}</s> ${formatMoney(item.line_price)}</p>`
      : `<p class="gw-drawer__product-price">${formatMoney(item.line_price)}</p>`;
    const discountNames=hasDiscount&&item.discounts&&item.discounts.length
      ? `<p class="gw-drawer__product-discount">${escapeHtml(item.discounts.map(function(d){return d.title;}).join(', '))}</p>`
      : '';
    el.innerHTML=`
      <img src="${item.image||''}" alt="${escapeHtml(item.product_title)}">
      <div class="gw-drawer__product-info">
        <p class="gw-drawer__product-title">${escapeHtml(item.product_title)}</p>
        ${vt?`<p class="gw-drawer__product-variant">${escapeHtml(vt)}</p>`:''}
        ${forLabel?`<p class="gw-drawer__product-for">${escapeHtml(forPropKey)}: ${escapeHtml(forLabel)}</p>`:''}
        ${discountNames}
        <span class="gw-drawer__badge-slot">${webExclusiveBadgeHtml(tags)}${bundleBadgeHtml(tags)}</span>
        <div class="gw-drawer__line-row">
          <div class="gw-drawer__stepper" role="group" aria-label="Quantity">
            <button type="button" class="gw-drawer__step-btn" data-step="-1" aria-label="Decrease quantity">−</button>
            <span class="gw-drawer__qty" aria-live="polite">${item.quantity}</span>
            <button type="button" class="gw-drawer__step-btn" data-step="1" aria-label="Increase quantity">+</button>
          </div>
          ${priceHtml}
        </div>
        <p class="gw-drawer__line-message" data-line-message hidden></p>
      </div>
      <button type="button" class="gw-drawer__remove" aria-label="Remove ${escapeHtml(item.product_title)}">&times;</button>
    `;
    if(isNew){
      setTimeout(function(){ el.classList.remove('gw-drawer__product-item--new'); },2200);
    }
    return el;
  }

  /* Renders the WHOLE cart every time — not just what was just added —
     so the subtotal shown always matches the lines shown (round 3's
     main fix: previously only the just-added item(s) were listed while
     the subtotal covered the entire basket). `justAddedVariantIds` is an
     array of variant ids to briefly highlight; pass [] to render with no
     highlight (used when opening from the header cart icon). Fetches
     every line's product data ONCE up front (cached), uses it for that
     line's badges, then hands the same data straight to the upsell
     logic below — no separate/duplicate fetch pass for that. */
  function renderCart(cart, justAddedVariantIds){
    currentCart=cart;
    updateHeaderCount(cart);
    document.dispatchEvent(new CustomEvent('gw:cart:change',{detail:{cart:cart}}));
    const wrap=document.getElementById('gw-drawer-product');
    const upsellEl=document.getElementById('gw-drawer-upsell');
    if(!cart.items.length){
      wrap.innerHTML='';
      wrap.appendChild(renderEmptyState());
      if(upsellEl) upsellEl.innerHTML='';
      updateCartTotals(cart);
      return;
    }
    justAddedVariantIds=justAddedVariantIds||[];
    const lookups=cart.items.map(function(item){
      return fetchProductData(item.handle).then(function(data){ return {item:item,data:data}; });
    });
    Promise.all(lookups).then(function(results){
      wrap.innerHTML='';
      results.forEach(function(r){
        const isNew=justAddedVariantIds.indexOf(r.item.variant_id)!==-1;
        wrap.appendChild(renderLine(r.item,isNew,r.data));
      });
      updateCartTotals(cart);
      // Upsell loads after the basket list is visible, not before —
      // keeps the drawer feeling instant even if the upsell logic's own
      // extra lookups (candidate search etc.) take a beat longer.
      updateUpsell(cart,results,justAddedVariantIds);
    });
  }

  function renderEmptyState(){
    const el=document.createElement('div');
    el.className='gw-drawer__empty';
    el.innerHTML=`<p class="gw-drawer__empty-text">Your bag is empty</p><button type="button" class="gw-drawer__empty-continue">Continue shopping</button>`;
    el.querySelector('.gw-drawer__empty-continue').addEventListener('click',closeDrawer);
    return el;
  }

  function showAddedBanner(){
    const banner=document.querySelector('.gw-drawer__added');
    if(!banner)return;
    banner.classList.add('is-visible');
    clearTimeout(showAddedBanner._t);
    showAddedBanner._t=setTimeout(function(){ banner.classList.remove('is-visible'); },2600);
  }

  function hideAddedBanner(){
    const banner=document.querySelector('.gw-drawer__added');
    if(banner) banner.classList.remove('is-visible');
  }

  /* Round 4: the page behind must stay scrollable while the drawer is
     open (no body scroll-lock) — removed the overflow:hidden toggle
     entirely. The drawer panel itself gets overscroll-behavior:contain
     (CSS) so scrolling inside it never "leaks" into the page once it
     hits the top/bottom of the list. */
  function openDrawerWithCart(cart, opts){
    opts=opts||{};
    const drawer=document.getElementById('gw-cart-drawer');
    renderCart(cart, opts.justAddedVariantIds||[]);
    if(opts.showAdded){ showAddedBanner(); } else { hideAddedBanner(); }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
  }

  function closeDrawer(){
    const drawer=document.getElementById('gw-cart-drawer');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
  }

  /* ---- Smart upsell (replaces the old collection-based "Fans also
     love") ----------------------------------------------------------
     Priority order, matching the brief exactly:
       A) complete a deal — an incomplete bundle-3-for-N group in the
          basket (quantity in that tag group isn't a multiple of 3)
       B) matching items — same design as the most recently added line
          (design name = the part of its title before the first " - "
          or " – ", the same convention product titles already use;
          confirmed live via predictive search that a plain text query
          on that fragment returns genuinely related products)
       C) same franchise fallback — Shopify's own /recommendations
          endpoint, filtered to the anchor's franchise: tag
     `results` is the [{item,data}] array renderCart just fetched for
     the line badges — reused here instead of a second fetch pass. */

  function isExcludedHandle(handle){
    return CASE_HANDLES.indexOf(handle)!==-1;
  }

  function findIncompleteBundleGroup(results){
    var groups={}; // tag -> {qty, franchiseTag}
    results.forEach(function(r){
      var tags=r.data&&r.data.tags;
      var bundleTag=bundleTagOf(tags);
      if(!bundleTag) return;
      if(!groups[bundleTag]) groups[bundleTag]={qty:0,franchiseTag:null};
      groups[bundleTag].qty+=r.item.quantity;
      var fr=franchiseTagOf(tags);
      if(fr) groups[bundleTag].franchiseTag=fr;
    });
    var incompleteTag=null;
    Object.keys(groups).forEach(function(tag){
      if(incompleteTag) return;
      if(groups[tag].qty%3!==0) incompleteTag=tag;
    });
    return incompleteTag?{tag:incompleteTag,info:groups[incompleteTag]}:null;
  }

  /* Read once — sections/gw-addon-offer-data.liquid, a static section
     rendered sitewide in layout/theme.liquid so this works on ANY page,
     not just the offer product's own (the beanie can be added from the
     homepage spotlight, a quick-add card, or search, none of which ever
     load main-product.liquid's own picker). One offer today; if a
     second is ever needed at the same time this would need to become a
     list, but nothing else here assumes there's only ever one. */
  var addonOfferConfigCache;
  function getAddonOfferConfig(){
    if(addonOfferConfigCache!==undefined) return addonOfferConfigCache;
    var el=document.getElementById('gw-addon-offer-config');
    try{
      var cfg=el?JSON.parse(el.textContent):null;
      addonOfferConfigCache=(cfg&&cfg.enabled&&cfg.trigger_tag)?cfg:null;
    }catch(e){ addonOfferConfigCache=null; }
    return addonOfferConfigCache;
  }

  /* Finds an add-on-offer "trigger" product (e.g. the beanie) in the
     basket with fewer LINKED add-ons (gloves whose _for_variant points
     back to it) than its own quantity — same _for_variant link the
     Pop/case cascade already uses, so a glove added any other way (not
     through this deal row) still counts correctly. Returns the first
     under-served trigger line found; null if none or if every trigger
     already has enough linked add-ons. */
  function findAddonOfferDeal(results){
    var config=getAddonOfferConfig();
    if(!config) return null;
    var triggers=results.filter(function(r){ return r.data&&(r.data.tags||[]).indexOf(config.trigger_tag)!==-1; });
    if(!triggers.length) return null;
    for(var i=0;i<triggers.length;i++){
      var t=triggers[i];
      var linkedQty=results.reduce(function(sum,r){
        var forVariant=r.item.properties&&r.item.properties._for_variant;
        return sum+(String(forVariant)===String(t.item.variant_id)?r.item.quantity:0);
      },0);
      if(linkedQty<t.item.quantity){
        return{config:config,missing:t.item.quantity-linkedQty,triggerVariantId:t.item.variant_id,triggerTitle:t.item.product_title};
      }
    }
    return null;
  }

  function predictiveSearchProducts(query,limit){
    return fetch('/search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]='+(limit||10)+'&resources[options][unavailable_products]=hide')
      .then(function(r){return r.json();})
      .then(function(d){return (d.resources&&d.resources.results&&d.resources.results.products)||[];})
      .catch(function(){return [];});
  }

  /* Predictive search results don't carry a stable numeric `product_id`
     matching cart lines' product_id in every store config, so "already
     in cart" / dedupe here checks by handle instead (always present and
     always matches). */
  function inCartHandles(results){
    return results.map(function(r){return r.item.handle;});
  }

  /* Predictive search results don't carry a usable price (a decimal
     string, not integer minor units) or a real variant id at all — same
     issue documented in assets/gw-product-matching.js. Every shortlisted
     deal candidate gets re-fetched through that module's own
     gw-product-data endpoint so the rendered card has a correct price
     and an actual add-to-cart variant id, same as the character/
     franchise tiers. */
  function hydrateDealCandidates(handles){
    if(typeof window.gwProductMatchingHelpers === 'undefined') return Promise.resolve([]);
    return Promise.all(handles.map(window.gwProductMatchingHelpers.fetchProductData)).then(function(dataList){
      return dataList.filter(function(d){return d && d.available!==false;});
    });
  }

  function dealCandidates(bundleTag, franchiseTag, results){
    var query='tag:'+bundleTag+(franchiseTag?' tag:'+franchiseTag:'');
    return predictiveSearchProducts(query,12).then(function(products){
      var excludeHandles=inCartHandles(results);
      var filtered=products.filter(function(p){
        return !isExcludedHandle(p.handle) && p.available!==false && excludeHandles.indexOf(p.handle)===-1;
      });
      if(franchiseTag && filtered.length<3){
        // Franchise-filtered search came up short — retry without it
        // rather than showing too few (or zero) candidates.
        return predictiveSearchProducts('tag:'+bundleTag,12).then(function(products2){
          var filtered2=products2.filter(function(p){
            return !isExcludedHandle(p.handle) && p.available!==false && excludeHandles.indexOf(p.handle)===-1;
          });
          return hydrateDealCandidates(filtered2.slice(0,4).map(function(p){return p.handle;}));
        });
      }
      return hydrateDealCandidates(filtered.slice(0,4).map(function(p){return p.handle;}));
    });
  }

  /* Character/franchise matching itself now lives in the shared
     assets/gw-product-matching.js (used by this drawer AND the product
     page's "You may also like" section — one decision, not two copies).
     This just supplies the cart-specific exclusion list and unwraps the
     {tier, products} result into the two outcomes updateUpsell cares
     about. */
  // Blends the two anchors' own (already per-anchor capped) results into
  // one list, deduping by handle and re-capping per type across the
  // COMBINED set — otherwise two anchors that each independently return,
  // say, 2 pin badges would show 4 pin badges and nothing else.
  function mergeAndCapByType(lists, maxPerType, limit){
    var counts={}, seen={}, out=[];
    lists.forEach(function(list){
      list.forEach(function(p){
        if(out.length>=limit) return;
        if(seen[p.handle]) return;
        var t=p.product_type||'unknown';
        counts[t]=counts[t]||0;
        if(counts[t]>=maxPerType) return;
        counts[t]++; seen[p.handle]=true; out.push(p);
      });
    });
    return out;
  }

  function matchOrFranchiseCandidates(anchorItem, results){
    if(typeof window.gwFindMatchingProducts !== 'function') return Promise.resolve({tier:'none',products:[]});
    return window.gwFindMatchingProducts(anchorItem.handle,{
      excludeHandles:inCartHandles(results),
      caseHandles:CASE_HANDLES,
      limit:4,
      maxPerType:2,
    });
  }

  function renderUpsellRow(heading, products){
    const el=document.getElementById('gw-drawer-upsell');
    if(!el) return;
    if(!products.length){ el.innerHTML=''; return; }
    let html=`<p class="gw-drawer__upsell-title">${escapeHtml(heading)}</p>`+
      `<div class="gw-drawer__upsell-wrap">`+
      `<div class="gw-drawer__upsell-row" data-upsell-track>`;
    const stickerConfig=getAddonOfferConfig();
    products.forEach(function(u){
      const multiVariant=u.variants_count>1;
      const hasSticker=stickerConfig&&stickerConfig.sticker_tag&&(u.tags||[]).indexOf(stickerConfig.sticker_tag)!==-1;
      html+=`<div class="gw-drawer__upsell-card">`+
        (hasSticker?`<img class="gw-offer-sticker gw-offer-sticker--small" src="${stickerConfig.sticker_url}" alt="" aria-hidden="true">`:'')+
        `<img src="${u.featured_image||''}" alt="${escapeHtml(u.title)}">`+
        `<p class="gw-drawer__upsell-name">${escapeHtml((u.title||'').split(' - ')[0])}</p>`+
        `<p class="gw-drawer__upsell-price">${formatMoney(u.price)}</p>`+
        (multiVariant
          ? `<a class="gw-drawer__upsell-btn gw-drawer__upsell-btn--link" href="${u.url}">Select</a>`
          : `<button type="button" class="gw-drawer__upsell-btn" data-variant-id="${u.first_variant_id}">+ Add</button>`)+
        `</div>`;
    });
    html+='</div>'+
      // Same round ‹ › arrow pattern as new-arrivals-carousel.js, sized
      // and coloured for the drawer's dark background.
      `<button type="button" class="gw-drawer__upsell-arrow gw-drawer__upsell-arrow--prev" aria-label="Previous">&#8249;</button>`+
      `<button type="button" class="gw-drawer__upsell-arrow gw-drawer__upsell-arrow--next" aria-label="Next">&#8250;</button>`+
      '</div>';
    el.innerHTML=html;
    el.querySelectorAll('.gw-drawer__upsell-btn:not(.gw-drawer__upsell-btn--link)').forEach(function(btn){
      btn.addEventListener('click',function(){
        if (window.location.pathname.includes('hexbox-case-file')) return;
        const id=this.dataset.variantId;
        this.disabled=true;
        this.textContent='Adding...';
        const b=this;
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
          .then(function(r){return r.json();})
          .then(function(item){
            fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
              openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:[item.variant_id]});
            });
          })
          .catch(function(){ b.disabled=false; b.textContent='+ Add'; });
      });
    });
    wireUpsellArrows(el);
  }

  function wireUpsellArrows(el){
    const track=el.querySelector('[data-upsell-track]');
    const prev=el.querySelector('.gw-drawer__upsell-arrow--prev');
    const next=el.querySelector('.gw-drawer__upsell-arrow--next');
    if(!track) return;
    function cardStep(){
      const card=track.querySelector('.gw-drawer__upsell-card');
      return card?card.offsetWidth+12:120;
    }
    function updateArrows(){
      const atStart=track.scrollLeft<=0;
      const atEnd=track.scrollLeft+track.clientWidth>=track.scrollWidth-1;
      if(prev){ prev.classList.toggle('is-disabled',atStart); }
      if(next){ next.classList.toggle('is-disabled',atEnd); }
    }
    if(prev) prev.addEventListener('click',function(){ track.scrollBy({left:-cardStep(),behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ track.scrollBy({left:cardStep(),behavior:'smooth'}); });
    track.addEventListener('scroll',updateArrows,{passive:true});
    updateArrows();
  }

  /* The add-on-offer deal row (e.g. beanie + gloves) — generic for any
     offer described by sections/gw-addon-offer-data.liquid. Each card
     fetches its own full product data (variants/options/availability)
     on demand so sizes can be offered inline, same size-required rule
     as the picker on the product page: if a product has more than one
     variant with a "Size" option, clicking "+ Add" reveals size pills
     first instead of adding immediately. */
  /* Bolds the first £amount (the actual deal price) and lightens a
     trailing "(was £X)" so the heading reads at a glance — generic
     string formatting, not tied to this specific offer's wording, so
     any future add-on offer's own heading text gets the same styling
     for free. */
  function formatDealHeading(text){
    return escapeHtml(text)
      .replace(/(£\d+(?:\.\d{2})?)/, '<strong class="gw-drawer__deal-heading-price">$1</strong>')
      .replace(/(\(was[^)]*\))/i, '<span class="gw-drawer__deal-heading-was">$1</span>');
  }

  function renderAddonDealRow(deal){
    const el=document.getElementById('gw-drawer-upsell');
    if(!el) return;
    const config=deal.config;
    Promise.all(config.products.map(function(h){ return fetchProductData(h); })).then(function(products){
      const valid=products.filter(function(p){ return p&&p.variants&&p.variants.some(function(v){return v.available;}); });
      if(!valid.length){ el.innerHTML=''; return; }
      let html=`<p class="gw-drawer__deal-heading">${formatDealHeading(config.heading)}</p>`+
        `<div class="gw-drawer__deal-row">`;
      valid.forEach(function(p,i){
        html+=`<div class="gw-drawer__deal-card" data-index="${i}">`+
          `<img src="${p.featured_image?p.featured_image.replace(/\.(png|jpe?g|webp)/,'_160x.$1'):''}" alt="${escapeHtml(p.title)}">`+
          `<p class="gw-drawer__deal-name">${escapeHtml(p.title.split(' - ')[0])}</p>`+
          `<div class="gw-drawer__deal-sizes" hidden></div>`+
          `<button type="button" class="gw-drawer__deal-btn">+ Add</button>`+
          `</div>`;
      });
      html+='</div>';
      el.innerHTML=html;

      el.querySelectorAll('.gw-drawer__deal-card').forEach(function(card){
        const p=valid[parseInt(card.dataset.index,10)];
        // product.options from /products/{handle}.js is an array of
        // OBJECTS ({name, position, values}), not plain strings — testing
        // the object itself against /size/i always coerced to the
        // literal string "[object Object]" and never matched, which is
        // why "+ Add" was adding the first variant straight away instead
        // of asking for a size. Test o.name instead.
        const sizeOptionIndex=(p.options||[]).findIndex(function(o){ return /size/i.test(o.name); });
        const discountMinor=(config.discount_amount||0)*100;
        const btn=card.querySelector('.gw-drawer__deal-btn');
        const sizesEl=card.querySelector('.gw-drawer__deal-sizes');

        function addVariant(variant){
          const properties={};
          properties[config.property_label]=deal.triggerTitle;
          properties._for_variant=deal.triggerVariantId;
          btn.disabled=true; btn.textContent='Adding...';
          window.gwInterceptAddToCartMulti([{id:variant.id,quantity:deal.missing,properties:properties}])
            .catch(function(){ btn.disabled=false; btn.textContent='+ Add'; });
        }

        function priceLabel(variant){
          const now=Math.max(0,variant.price-discountMinor);
          return `${formatMoney(now)} <s>${formatMoney(variant.price)}</s>`;
        }

        // Distinct variants by size only (collapses any other option
        // dimension, e.g. a colour variant, to whichever comes first for
        // that size) — same simplification as the product-page picker.
        const sizeVariants=[];
        if(sizeOptionIndex>-1){
          const seen={};
          (p.variants||[]).forEach(function(v){
            const size=v.options[sizeOptionIndex];
            if(size&&!seen[size]){ seen[size]=true; sizeVariants.push({size:size,variant:v}); }
          });
        }

        if(sizeOptionIndex===-1||sizeVariants.length<=1){
          const variant=(p.variants||[]).find(function(v){return v.available;});
          card.querySelector('.gw-drawer__deal-name').insertAdjacentHTML('afterend',`<p class="gw-drawer__deal-price">${priceLabel(variant)}</p>`);
          btn.addEventListener('click',function(){ if(variant) addVariant(variant); });
          return;
        }

        card.querySelector('.gw-drawer__deal-name').insertAdjacentHTML('afterend',`<p class="gw-drawer__deal-price">${formatMoney(Math.max(0,sizeVariants[0].variant.price-discountMinor))} <s>${formatMoney(sizeVariants[0].variant.price)}</s></p>`);
        btn.addEventListener('click',function(){
          if(!sizesEl.hidden) return;
          sizesEl.hidden=false;
          sizesEl.innerHTML=sizeVariants.map(function(sv){
            return `<button type="button" class="gw-size-pill"${sv.variant.available?'':' disabled'}>${escapeHtml(sv.size)}</button>`;
          }).join('');
          Array.from(sizesEl.children).forEach(function(pillEl,idx){
            if(pillEl.disabled) return;
            pillEl.addEventListener('click',function(){ addVariant(sizeVariants[idx].variant); });
          });
        });
      });
    });
  }

  function updateUpsell(cart, results, justAddedVariantIds){
    const el=document.getElementById('gw-drawer-upsell');
    if(!el) return;
    if(!cart.items.length){ el.innerHTML=''; return; }

    const addonDeal=findAddonOfferDeal(results);
    if(addonDeal){ renderAddonDealRow(addonDeal); return; }

    const deal=findIncompleteBundleGroup(results);
    if(deal){
      const missing=3-(deal.info.qty%3);
      const heading='Add '+missing+' more to get 3 for £'+bundlePriceLabel(deal.tag);
      dealCandidates(deal.tag,deal.info.franchiseTag,results).then(function(products){
        renderUpsellRow(heading,products);
      });
      return;
    }

    // Anchors are picked from the WHOLE basket, not just the last line —
    // and never from a case or a bundle item (pop-case-picker cases carry
    // zero tags of any kind, so using one as the anchor was falling
    // straight through to the generic recommendations fallback with no
    // real signal to work from — confirmed live, that's what was
    // surfacing coasters). Ranked by quantity (the customer's clearest
    // signal of what they actually care about), ties broken by whichever
    // was added most recently / is furthest along in the cart.
    var anchorCandidates=results.filter(function(r){
      return !isExcludedHandle(r.item.handle) && !bundleTagOf(r.data&&r.data.tags);
    });
    if(!anchorCandidates.length){ el.innerHTML=''; return; }
    var justAddedSet=(justAddedVariantIds||[]);
    anchorCandidates.sort(function(a,b){
      if(b.item.quantity!==a.item.quantity) return b.item.quantity-a.item.quantity;
      var aJust=justAddedSet.indexOf(a.item.variant_id)!==-1?1:0;
      var bJust=justAddedSet.indexOf(b.item.variant_id)!==-1?1:0;
      if(bJust!==aJust) return bJust-aJust;
      return results.indexOf(b)-results.indexOf(a);
    });
    var topAnchors=anchorCandidates.slice(0,2);

    Promise.all(topAnchors.map(function(r){ return matchOrFranchiseCandidates(r.item,results); })).then(function(anchorResults){
      var primary=anchorResults[0];
      var heading=(primary.tier==='design'||primary.tier==='character')?'Complete the set':'Fans also love';
      var products=mergeAndCapByType(anchorResults.map(function(r){return r.products;}),2,4);
      renderUpsellRow(heading,products);
    });
  }

  function interceptAddToCart(variantId, quantity, collection, sellingPlan) {
    const body = { id: variantId, quantity: quantity || 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(r => r.json())
      .then(item => {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:[item.variant_id]});
        });
      });
  }

  /* Pop Protector case picker (assets/pop-case-picker.js) adds the Pop and
     the chosen case in ONE /cart/add.js request using its `items` array
     form, rather than the single-item form interceptAddToCart uses above.
     Shopify's items-array endpoint REJECTS the whole request if any line
     can't be fulfilled in most cases, but real testing against this store
     also surfaced a partial-fulfillment response (a quantity silently
     capped down rather than the request being rejected outright) — so
     this doesn't trust atomicity blindly. If the number of lines Shopify
     actually added doesn't match what was asked for, that's treated as a
     failure too: everything just added is removed again via /cart/change.js
     before rejecting, so the Pop is never left in the cart on its own
     just because the case's stock ran out mid-request. Returns a promise
     so the caller can show its own friendly message on rejection; a
     genuine network/parse failure (not a Shopify error payload) rejects
     with a plain, generic object rather than leaking a raw parse error to
     the customer. */
  function interceptAddToCartMulti(items) {
    var genericError = { description: "That case just sold out — nothing was added. Try again or pick a different case." };

    function rollBack(addedItems) {
      var changes = addedItems.map(function (item) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });
      return Promise.all(changes).catch(function () {});
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () { return Promise.reject(genericError); })
          .then(function (data) {
            if (!r.ok || data.status) return Promise.reject(data);
            return data;
          });
      })
      .then(function (data) {
        var addedItems = data.items || [];
        if (addedItems.length !== items.length) {
          return rollBack(addedItems).then(function () { return Promise.reject(genericError); });
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var variantIds = addedItems.map(function(item){ return item.variant_id; });
          openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:variantIds});
        });
      });
  }

  /* ---- Line controls: stepper + remove, event-delegated on the list -----
     One listener on the container rather than one per button, since the
     whole list is rebuilt on every render. `data-loading` on the row
     guards against a double-tap firing a second request before the first
     one's response (and re-render) lands. */
  function setRowLoading(row,loading){
    if(loading) row.setAttribute('data-loading','1');
    else row.removeAttribute('data-loading');
  }

  function showLineMessage(row,text){
    const msg=row.querySelector('[data-line-message]');
    if(!msg)return;
    msg.textContent=text;
    msg.hidden=false;
    clearTimeout(msg._t);
    msg._t=setTimeout(function(){ msg.hidden=true; },3200);
  }

  function changeLine(key,quantity){
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:quantity})})
      .then(function(r){return r.json();});
  }

  function afterLineChange(cartOrPromise,row,requestedQty){
    return Promise.resolve(cartOrPromise).then(function(cart){
      return applyCaseLinkRules(cart).then(function(finalCart){
        // If the server capped the quantity below what we asked for (out
        // of stock), the line we changed will show a lower quantity than
        // requested — say so, briefly, before the row is rebuilt away.
        if(row&&typeof requestedQty==='number'){
          var key=row.dataset.key;
          var line=finalCart.items.find(function(i){return i.key===key;});
          var actualQty=line?line.quantity:0;
          if(actualQty<requestedQty && actualQty>0){
            showLineMessage(row,'Only '+actualQty+' left');
          }
        }
        renderCart(finalCart,[]);
      });
    });
  }

  function wireLineControls(){
    const wrap=document.getElementById('gw-drawer-product');
    wrap.addEventListener('click',function(e){
      const stepBtn=e.target.closest('[data-step]');
      const removeBtn=e.target.closest('.gw-drawer__remove');
      const row=e.target.closest('.gw-drawer__product-item');
      if(!row)return;
      if(row.getAttribute('data-loading')==='1')return;

      if(removeBtn){
        setRowLoading(row,true);
        changeLine(row.dataset.key,0).then(function(cart){ return afterLineChange(cart,row,0); });
        return;
      }

      if(stepBtn){
        const delta=parseInt(stepBtn.dataset.step,10);
        const qtyEl=row.querySelector('.gw-drawer__qty');
        const current=parseInt(qtyEl.textContent,10)||0;
        let next=current+delta;

        if(delta>0 && row.dataset.forVariant && currentCart){
          // A case line's + can't take it above its linked Pop's
          // quantity — capped client-side first (cheap, instant), the
          // server-side applyCaseLinkRules call below is the real
          // source of truth and would also fix this if it somehow got
          // past this check.
          const pop=currentCart.items.find(function(i){return String(i.variant_id)===String(row.dataset.forVariant);});
          const cap=pop?pop.quantity:0;
          if(next>cap){
            showLineMessage(row,'Max '+cap+' — matches your Pop\'s quantity');
            return;
          }
        }

        if(next<1){
          setRowLoading(row,true);
          changeLine(row.dataset.key,0).then(function(cart){ return afterLineChange(cart,row,0); });
          return;
        }

        setRowLoading(row,true);
        changeLine(row.dataset.key,next).then(function(cart){ return afterLineChange(cart,row,next); });
      }
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    const drawer=document.getElementById('gw-cart-drawer');
    if(!drawer)return;
    drawer.querySelector('.gw-drawer__close').addEventListener('click',closeDrawer);
    drawer.querySelector('.gw-drawer__continue').addEventListener('click',closeDrawer);
    wireLineControls();

    /* Round 4: click/tap anywhere outside the panel closes the drawer
       (previously deliberately didn't, to let a customer keep browsing
       behind it — reversed on request). The overlay stays
       pointer-events:none (gw-cart-drawer.css) and clicks are caught
       here via document-level delegation instead, so this ALSO closes
       on a click straight through to a real page element behind the
       overlay, not just a click on the dimmed overlay itself.
       Distinguishes a genuine tap from a scroll/swipe ending under the
       pointer (a real risk on touch) by comparing the pointerdown and
       click positions — anything that moved more than a few px was a
       drag/swipe, not a tap, and is ignored. */
    var outsideStart=null;
    document.addEventListener('pointerdown',function(e){
      outsideStart={x:e.clientX,y:e.clientY};
    });
    document.addEventListener('click',function(e){
      if(!drawer.classList.contains('is-open')) return;
      const panel=drawer.querySelector('.gw-drawer__panel');
      if(panel.contains(e.target)) return;
      if(e.target.closest('#cart-icon-bubble')) return;
      if(outsideStart){
        const dx=Math.abs((e.clientX||0)-outsideStart.x);
        const dy=Math.abs((e.clientY||0)-outsideStart.y);
        if(dx>8||dy>8) return;
      }
      closeDrawer();
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    document.addEventListener('gwCartAdd', function(e) {
      if (window.location.pathname.includes('hexbox-case-file')) return;
      interceptAddToCart(e.detail.variantId, 1, e.detail.collection, e.detail.sellingPlan);
    });

    /* Header cart icon: opens the SAME drawer showing the full basket,
       instead of navigating to /cart, wherever the drawer exists on the
       page. No "Added to your bag" banner here — nothing was just
       added, the customer is just checking their bag. */
    const cartIcon=document.getElementById('cart-icon-bubble');
    if(cartIcon){
      cartIcon.addEventListener('click',function(e){
        e.preventDefault();
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
          openDrawerWithCart(cart,{showAdded:false,justAddedVariantIds:[]});
        });
      });
    }
  });

  /* /cart page (Dawn's stock main-cart-items + assets/cart.js) has its own
     quantity controls, entirely separate from this drawer. Rather than
     rewriting that stock component, this hooks Dawn's own pubsub event
     (fired after every one of ITS successful /cart/change.js calls) and
     runs the exact same case-link cascade, then reloads the page so the
     fix is reflected — correctness over smoothness on this secondary
     path, since the drawer is the primary, polished flow. */
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (payload) {
      var cart = payload && payload.cartData;
      if (!cart || !cart.items) return;
      applyCaseLinkRules(cart).then(function (finalCart) {
        if (finalCart !== cart) window.location.reload();
      });
    });
  }

  window.gwOpenCartDrawer=function(p,cart){ openDrawerWithCart(cart,{showAdded:true,justAddedVariantIds:p&&p.variant_id?[p.variant_id]:[]}); };
  window.gwInterceptAddToCart=interceptAddToCart;
  window.gwInterceptAddToCartMulti=interceptAddToCartMulti;

  /* Promise-based variant of interceptAddToCart, added for the tarot
     deck's "In the bag" success/failure UI (A3) — interceptAddToCart
     itself is left untouched since other callers (franchise page,
     bundle builder, etc.) already depend on its exact fire-and-forget
     behaviour. /cart/add.js returns a 4xx body with a `status`/`message`
     on failure (e.g. sold out) rather than throwing, so success is
     judged by the response having a real line-item id, not just by the
     fetch resolving. */
  function addToCartWithResult(variantId, quantity, collection, sellingPlan, opts) {
    const body = { id: variantId, quantity: quantity || 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(r => r.json().then(item => ({ ok: r.ok, item: item })))
      .then(result => {
        if (!result.ok || !result.item || !result.item.id) {
          const message = (result.item && result.item.description) || (result.item && result.item.message) || 'That item is unavailable right now.';
          return Promise.reject({ message: message });
        }
        return fetch('/cart.js').then(r => r.json()).then(cart => {
          if (opts && opts.noDrawer) {
            updateHeaderCount(cart);
            document.dispatchEvent(new CustomEvent('gw:cart:change', { detail: { cart: cart } }));
          } else {
            openDrawerWithCart(cart, { showAdded: true, justAddedVariantIds: [result.item.variant_id] });
          }
          return result.item;
        });
      })
      .catch(err => {
        if (err && err.message) return Promise.reject(err);
        return Promise.reject({ message: 'That item is unavailable right now.' });
      });
  }
  window.gwAddToCartWithResult=addToCartWithResult;
})();
